module.exports = __webpack_public_path__ + "img/ring_r_skip_1_1@3x.9771ce57.png";